import { GridColumnType } from '@grid'
import { GridPreProcessEditCellProps } from '@mui/x-data-grid'
import { Validator, ValidatorResultType } from '@validators'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export const ItemColumns: GridColumnType = {
	initRow: {
		code: '',
		name: '',
		usd: 0,
		krw: 0,
		discountUsd: 0,
		discountKrw: 0,
		materialCostUsd: null,
		materialCostKrw: null,
		index: 0,
		quantity: 0,
		useYn: 0,
		alwaysAvailableYn: 0,
		updatedBy: '',
		updatedAt: '',
		createdBy: '',
		createdAt: dayjs().format('YYYY-MM-DD HH:mm:ss'),
	},
	fieldToFocus: 'code',
	card: {
		title: 'name',
		subtitle: 'code',
		meta: ['usd', 'krw', 'useYn', 'soldoutYn'],
		sections: [
			{
				title: '가격',
				fields: [
					'code',
					'usd',
					'krw',
					'discountUsd',
					'discountKrw',
					'materialCostUsd',
					'materialCostKrw',
				],
			},
			{
				title: '판매',
				fields: ['useYn', 'alwaysAvailableYn', 'soldoutYn', 'quantity', 'index'],
			},
		],
	},
	columns: [
		{
			field: 'code',
			headerName: '코드',
			headerAlign: 'center',
			width: 150,
			editable: true,
		},
		{
			field: 'name',
			headerName: '이름',
			headerAlign: 'center',
			width: 150,
			editable: true,
		},
		{
			field: 'usd',
			headerName: '기준단가(USD)',
			headerAlign: 'center',
			width: 100,
			editable: true,
			valueFormatter: (value: number) =>
				value.toLocaleString('en-US', {
					style: 'currency',
					currency: 'USD',
				}),
			align: 'right',
		},
		{
			field: 'krw',
			headerName: '기준단가(KRW)',
			headerAlign: 'center',
			width: 100,
			editable: true,
			valueFormatter: (value: number) =>
				value.toLocaleString('ko-KR', {
					style: 'currency',
					currency: 'KRW',
				}),
			align: 'right',
		},
		{
			field: 'discountUsd',
			headerName: '할인단가(USD)',
			headerAlign: 'center',
			width: 100,
			editable: true,
			valueFormatter: (value: number) =>
				value.toLocaleString('en-US', {
					style: 'currency',
					currency: 'USD',
				}),
			align: 'right',
		},
		{
			field: 'discountKrw',
			headerName: '할인단가(KRW)',
			headerAlign: 'center',
			width: 100,
			editable: true,
			valueFormatter: (value: number) =>
				value.toLocaleString('ko-KR', {
					style: 'currency',
					currency: 'KRW',
				}),
			align: 'right',
		},
		{
			field: 'materialCostUsd',
			headerName: '재료원가(USD)',
			headerAlign: 'center',
			width: 110,
			editable: true,
			type: 'number',
			valueFormatter: (value: number | null) =>
				value === null || value === undefined || value === ('' as any)
					? '-'
					: Number(value).toLocaleString('en-US', { style: 'currency', currency: 'USD' }),
			align: 'right',
		},
		{
			field: 'materialCostKrw',
			headerName: '재료원가(KRW)',
			headerAlign: 'center',
			width: 110,
			editable: true,
			type: 'number',
			valueFormatter: (value: number | null) =>
				value === null || value === undefined || value === ('' as any)
					? '-'
					: Number(value).toLocaleString('ko-KR', { style: 'currency', currency: 'KRW' }),
			align: 'right',
		},
		{
			field: 'quantity',
			headerName: '재고',
			headerAlign: 'center',
			width: 100,
			editable: true,
			align: 'right',
			valueFormatter: (value: number) => value.toLocaleString(),
		},
		{
			field: 'index',
			headerName: '순서',
			headerAlign: 'center',
			width: 100,
			editable: true,
			align: 'right',
			valueFormatter: (value: number) => (value === 0 ? '-' : value.toLocaleString()),
		},
		{
			field: 'useYn',
			headerName: '제품 활성화 여부',
			type: 'boolean',
			headerAlign: 'center',
			valueFormatter: (value: number) => (value === 1 ? true : false),
			width: 120,
			editable: true,
		},
		{
			field: 'alwaysAvailableYn',
			headerName: '상시판매 여부',
			type: 'boolean',
			headerAlign: 'center',
			valueFormatter: (value: number) => (value === 1 ? true : false),
			width: 100,
			editable: true,
		},
		{
			field: 'soldoutYn',
			headerName: '상시판매 품절 여부',
			type: 'boolean',
			headerAlign: 'center',
			valueFormatter: (value: number) => (value === 1 ? true : false),
			width: 130,
			editable: true,
		},
		{
			field: 'createdBy',
			headerName: '생성자',
			width: 200,
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'createdAt',
			headerName: '생성일시',
			type: 'dateTime',
			headerAlign: 'center',
			valueFormatter: (value: string) =>
				value !== '' ? dayjs(value).tz().format('YYYY-MM-DD HH:mm:ss') : '',
			width: 200,
			editable: false,
		},
		{
			field: 'updatedBy',
			headerName: '수정자',
			width: 200,
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'updatedAt',
			headerName: '수정일시',
			type: 'dateTime',
			headerAlign: 'center',
			valueFormatter: (value: string) =>
				value !== '' ? dayjs(value).tz().format('YYYY-MM-DD HH:mm:ss') : '',
			width: 200,
			editable: false,
		},
	],
}
